// 设置 
export function setPageTitle(title) {
    if (title) {
        if (window.document.title !== title) {
            window.document.title = title;
            if (window.dd && window.dd.setNavigationTitle) {
                window.dd.setNavigationTitle({
                    title: title,
                    success: () => { },
                    fail: () => { },
                    complete: () => { },
                });
            }
        }
    }
}